import { URL_SEARCH } from "../../../lib/constants/urls/urlSearch";
import { parishSearchResultSchema } from "../../../lib/types/schema/search/parishSearchResultSchema";
import { request } from "../../../request/request";
import { PARISH_SEARCH_DIRECTORY } from "./constants/elasticSearchDirectory.constants";

export const requestParishSearchRequestProps = (
  search: string,
  filters: { status?: Array<"active" | "launched"> },
) => ({
  body: JSON.stringify({
    filters,
    query: search,
  }),
  method: "POST",
  requestType: "search" as const,
  schema: parishSearchResultSchema,
  url: `${URL_SEARCH}/${PARISH_SEARCH_DIRECTORY}/search`,
});

export const requestParishSearch = async (
  search: string,
  filters: { status?: Array<"active" | "launched"> } = {
    status: ["active", "launched"],
  },
) =>
  request({
    ...requestParishSearchRequestProps(search, filters),
  });
